export default __webpack_public_path__ + "static/media/ic_invoice.257c58ed.svg";